var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27154 7.42406C8.08575 7.42406 7.94456 7.36461 7.84052 7.25314L4.77874 4.1765C4.64497 4.05016 4.59295 3.90153 4.59295 3.73061C4.59295 3.56712 4.65984 3.40362 4.77874 3.28472L7.84052 0.178356C7.94456 0.0594519 8.09319 0 8.27154 0C8.60596 0 8.85863 0.267534 8.85863 0.609382C8.85863 0.765444 8.79918 0.914073 8.69514 1.03298L6.71093 2.98003C7.13452 2.90571 7.56555 2.86112 7.99658 2.86112C11.638 2.86112 14.566 5.7817 14.566 9.42313C14.566 13.072 11.638 16 7.99658 16C4.35515 16 1.43457 13.072 1.43457 9.42313C1.43457 9.06642 1.68724 8.80632 2.05138 8.80632C2.40066 8.80632 2.63104 9.06642 2.63104 9.42313C2.63104 12.4106 5.01655 14.8035 7.99658 14.8035C10.9766 14.8035 13.3695 12.4106 13.3695 9.42313C13.3695 6.4431 10.9766 4.05759 7.99658 4.05759C7.43178 4.05759 6.91158 4.10218 6.46569 4.19879L8.68771 6.40595C8.79918 6.52485 8.85863 6.67348 8.85863 6.82954C8.85863 7.17139 8.60596 7.42406 8.27154 7.42406Z",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/resetIcon.ba8505f28334e8259f8cae631e3bb410.svg";
export { ForwardRef as ReactComponent };